const CONSTANTS = {
    TOKEN: 'TOKEN',
    USER_INFO: 'USER_INFO',
}

export default CONSTANTS;